export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/pianissimo-icon.svg?d137bed9a64f5d016235251e760c9298";